import React, { useEffect, useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { CoursesPage } from './pages/CoursesPage';
import { initGoogleTag } from './utils/gtag';
import { initGTM } from './utils/gtm';
type PaletteMode = 'light' | 'dark';
type Page = 'landing' | 'courses';
export function App() {
  const [mode, setMode] = useState<PaletteMode>('light');
  const [page, setPage] = useState<Page>('landing');
  const toggleMode = () => {
    const newMode = mode === 'light' ? 'dark' : 'light';
    setMode(newMode);
    document.documentElement.setAttribute('data-mode', newMode);
  };
  const goToCourses = () => {
    setPage('courses');
    window.scrollTo({
      top: 0
    });
  };
  const goToLanding = () => {
    setPage('landing');
    window.scrollTo({
      top: 0
    });
  };
  useEffect(() => {
    // Set initial mode on mount
    document.documentElement.setAttribute('data-mode', mode);
    // Initialize Google Analytics
    initGoogleTag();
    // Initialize Google Tag Manager
    initGTM();
  }, []);
  if (page === 'courses') {
    return <CoursesPage mode={mode} toggleMode={toggleMode} onBack={goToLanding} data-id="element-0" data-mp="3ihv1ac76whht" />;
  }
  return <LandingPage mode={mode} toggleMode={toggleMode} onViewCourses={goToCourses} data-id="element-1" data-mp="3mjg7xft4rzjk" />;
}